<script setup lang="ts">
    import type { FrontendFieldDefinition } from '@hmmh/storyblok-forms';
    import type { FormInputStoryblok } from '~/.storyblok/types/FormInputStoryblok';
    import FormInput from '~/storyblok/Form/FormInput.vue';
    import { isRequiredField } from './form-field-utils';

    const props = defineProps<{ field: FrontendFieldDefinition }>();

    const checkboxLabel = computed<FormInputStoryblok['checkboxLabel']>(
        () =>
            props.field.checkboxLabel ?? {
                type: 'doc',
                content: [
                    {
                        type: 'paragraph',
                        content: [{ type: 'text', text: props.field.label }]
                    }
                ]
            }
    );

    const blok = computed<FormInputStoryblok>(() => ({
        _uid: props.field.name,
        component: 'FormInput',
        inputKey: props.field.name,
        inputType: 'checkbox',
        checkboxLabel: checkboxLabel.value,
        required: isRequiredField(props.field),
        Value: props.field.value
    }));
</script>

<template>
    <FormInput :blok="blok" />
</template>
